import { ChevronUpIcon } from "lucide-react";
import { useEffect, useState } from "react";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        // <button
        //     onClick={scrollToTop}
        //             className={`fixed bottom-8 right-8 z-50 
        //         w-9 h-9 rounded-full shadow-lg
        //         bg-gradient-to-r  from-indigo-600 to-purple-600 text-white 
        //         flex items-center justify-center
        //         transition-all duration-300 hover:scale-105
        //         ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5 pointer-events-none"}
        //       `}
        //                 >
        //     <ChevronUpIcon />
        // </button>
        <button
            onClick={scrollToTop}
            className={`fixed bottom-8 right-8 z-50 
        w-10 h-10 rounded-full shadow-lg
        bg-gradient-to-r from-[#ff6968] to-rose-500 text-white 
        flex items-center justify-center
        transition-all duration-300 hover:scale-110 hover:shadow-[#ff6968]/30
        group  overflow-hidden
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5 pointer-events-none"}
    `}
        >
            <span className="absolute inset-0 bg-white/20 scale-0 group-hover:scale-100 rounded-full transition-transform duration-500" />
            <ChevronUpIcon className="w-5 h-5 relative z-10" />
        </button>


    );
}
